import * as tslib_1 from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { getInfoToDisplayImageDeviation } from './_helpers';
import s from './Image.scss';
import Unknown from '../Unknown';
import Flag from '../../../redux/flags/Flag';
import { BrowserFeatureContext } from '../../../Context/BrowserFeatureContext';
import { useInView } from 'react-intersection-observer';
import NoScript from './_partials/NoScript';
/**
 * If you are changing any fundamentals here please remember to also
 * consider the DaEditorWrapers image views
 */
var ImageDumbView = function (props) {
    var deviation = props.deviation, className = props.className, propsWidth = props.width, propsHeight = props.height, propsUseCoverMode = props.useCoverMode, // forced via props
    _a = props.allowPreviewUsage, // forced via props
    allowPreviewUsage = _a === void 0 ? true : _a, pagePerf = props.pagePerf, greenLikeCrop = props.greenLikeCrop, lazyload = props.lazyload;
    var _b = useInView({
        triggerOnce: true,
        threshold: 0,
        rootMargin: '50% 0% 50% 0%',
    }), ref = _b[0], inView = _b[1];
    var supportsWebp = useContext(BrowserFeatureContext).supportsWebp;
    if (!propsWidth && !propsHeight) {
        // no use-cases for responsive image views
        ddt.warn('deviationviews', 'Deviation image is not rendered because of missing Width and Height properties');
        return null;
    }
    var info = getInfoToDisplayImageDeviation({
        deviation: deviation,
        height: propsHeight,
        width: propsWidth,
        allowPreviewUsage: allowPreviewUsage,
        greenLikeCrop: greenLikeCrop,
    });
    if (!info || !info.pickedImage) {
        ddt.warn('deviationviews', 'Could not find a suitable image file to render deviation image', info);
        return React.createElement(Unknown, tslib_1.__assign({}, props));
    }
    var height = info.height, width = info.width, imgStyles = info.imgStyles, wrapperStyles = info.wrapperStyles, pickedImage = info.pickedImage;
    ddt.log('deviationviews.thumbtype', "Used " + pickedImage.type);
    // Gifs need special casing, there can be situation where
    // the gif file is HUGE we check the filesize for sanity
    if (pickedImage.type === 'gif' && (pickedImage.filesize || 0) > 300000) {
        ddt.log('deviationviews', 'Ignoring large GIF file - not suitable for thumbs', pickedImage);
        return React.createElement(Unknown, tslib_1.__assign({}, props));
    }
    var useCoverMode = info.useCoverMode || propsUseCoverMode;
    var imageProps = {};
    var ariaProps = {};
    // If covermode is used always include src as its then inside <noscript>
    // If not lazyloading always include src
    // If lazyloading, only include it when inView
    if (useCoverMode || !lazyload || inView) {
        imageProps.src = getImageSrc(pickedImage, supportsWebp, pagePerf);
    }
    // When not using covermode hide the image so we dont see the alt text
    // TODO better way to do this for accessibility
    if (!useCoverMode && lazyload && !inView) {
        imgStyles.display = 'none';
    }
    var wrapStyles = tslib_1.__assign({ width: width,
        height: height }, wrapperStyles);
    if (useCoverMode) {
        ariaProps.role = 'img';
        ariaProps['aria-label'] = deviation.title;
        if (!lazyload || inView) {
            wrapStyles.backgroundImage = "url(\"" + getImageSrc(pickedImage, supportsWebp, pagePerf) + "\")";
        }
    }
    return (React.createElement("div", tslib_1.__assign({ ref: lazyload ? ref : undefined }, ariaProps, { className: classnames(s['wrapper'], className, useCoverMode && s['cover-mode']), style: wrapStyles }),
        renderDebug(info.pickedImage, propsWidth, propsHeight),
        React.createElement(NoScript, { wrap: useCoverMode },
            React.createElement("img", tslib_1.__assign({ alt: deviation.title, style: imgStyles, className: s['image'] }, imageProps)))));
};
ImageDumbView.displayName = 'ImageDumbView';
function getImageSrc(pickedImage, supportsWebp, featureEnabled) {
    return supportsWebp && featureEnabled && pickedImage.srcWebp
        ? pickedImage.srcWebp
        : pickedImage.src;
}
function renderDebug(pickedImage, propsWidth, propsHeight) {
    return (React.createElement(Flag, { condition: "thumbdebug" },
        React.createElement("div", { className: s['thumb-debug'] },
            pickedImage.type,
            "/",
            pickedImage.src
                .replace(/\?.*/, '')
                .split('.')
                .pop(),
            "/",
            pickedImage.transparency === true ? 'true' : 'false',
            "/",
            React.createElement("abbr", { title: "imageDims" },
                pickedImage.width,
                "x",
                pickedImage.height),
            "/",
            React.createElement("abbr", { title: "blockDims" },
                propsWidth,
                "x",
                propsHeight))));
}
export default ImageDumbView;
//# sourceMappingURL=Image.js.map